import Vue from 'vue';
import {Component} from 'vue-property-decorator' ;
import {namespace} from 'vuex-class' ;
import {
  DOCUMENT_MODULE_NAMESPACE,
  DOCUMENT_SET_DOCUMENT_ACTION,
  DOCUMENT_RESET_DOCUMENT,
  DOCUMENT_RECORD_DOCUMENT,
  DOCUMENT_SAVE_DOCUMENT,
  DOCUMENT_UPDATE_DOCUMENT,
  DOCUMENT_SET_DOCUMENT_PARAMETER,
  DOCUMENT_GET_DOCUMENT_TYPES,
  DOCUMENT_GET_DOCUMENTS_ATTACHMENTS,
  DOCUMENT_SET_DOCUMENTS,
  DOCUMENT_SET_LOADER_STATE,
  DOCUMENT_LOADERS,
  DOCUMENT_SET_DOCUMENTS_PAGINATION
} from '../../store/document';
import {CrudStatus} from '../../common/enums';
import {AUTHORIZATION_MODULE_NAMESPACE, AUTHORIZATION_FUNCTIONALITIES} from '../../store/authorization';
import {IDocumentListingViewmodel, IDocumentParamter, IDocumentTypeListingViewmodel} from '../../models/documents';
import {IDocument} from '../../models/documents/document';
import { eventBus } from '../../main';


const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)
const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)

@Component({
  components: {
    'document-modal-vertical': async () => import('./components/document-modal-vertical/DocumentModalVertical.vue')
  }
})
class Document extends Vue {
  dtIsRecording: boolean;
  dtErrorModalVisible: boolean;
  dtError: boolean;
  dtCanCreate: boolean

  constructor() {
    super()
    this.dtIsRecording = false
    this.dtErrorModalVisible = false
    this.dtError = null
    this.dtCanCreate = false
  }

  @DocumentStore.Getter documentCrudActionStatus: CrudStatus
  @DocumentStore.Getter documentParameter: IDocumentParamter
  @DocumentStore.Getter document: IDocument
  @DocumentStore.Getter documents: IDocumentListingViewmodel[]
  @DocumentStore.Getter documentTypes: any[]

  @DocumentStore.Action(DOCUMENT_GET_DOCUMENT_TYPES)
  storeGetDocumentsTypes: () => Promise<any>

  @DocumentStore.Action(DOCUMENT_GET_DOCUMENTS_ATTACHMENTS)
  storeGetDocumentAttachments: () => Promise<any>

  @DocumentStore.Action(DOCUMENT_RESET_DOCUMENT)
  storeResetDocument: () => void

  @DocumentStore.Action(DOCUMENT_UPDATE_DOCUMENT)
  storeUpdateDocument: () => Promise<any>

  @DocumentStore.Action(DOCUMENT_SAVE_DOCUMENT)
  storeRecordDocument: () => Promise<any>

  @AuthorizationStore.Action(AUTHORIZATION_FUNCTIONALITIES)
  storeGetFunctionalities: (moduleName: string) => Promise<any>

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_ACTION)
  storeSetDocumentAction: (status: CrudStatus) => void

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT_PARAMETER)
  storeSetDocumentParameter: (payload: IDocumentParamter) => void

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENTS)
  storeSetDocumentsList: (documents: IDocumentListingViewmodel[]) => void

  @DocumentStore.Mutation(DOCUMENT_GET_DOCUMENT_TYPES)
  storeSetDocumentTypes: (documents: IDocumentTypeListingViewmodel[]) => void

  @DocumentStore.Mutation(DOCUMENT_SET_LOADER_STATE)
  storeSetLoaderState: (payload?: { key: string, value: boolean}) => void

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENTS_PAGINATION)
  storeSetDocumentPagination: (payload?: any) => void


  get lblSetting() {
    return {...require('../../locales/document').default}
  }

  get coKeyword(): string {
    return this.documentParameter.key
  }

  set coKeyword(val: string) {
    this.storeSetDocumentParameter({key: val})
    this.storeSetDocumentPagination({page: 1})
    if (this.$route.name === 'document_attachment') this.storeGetDocumentAttachments()
  }

  get isCreateAction(): boolean {
    return this.documentCrudActionStatus === CrudStatus.Create
  }

  get isUpdateAction(): boolean {
    return this.documentCrudActionStatus === CrudStatus.Update
  }

  get isOpenModal(): boolean {
    return this.isCreateAction || this.isUpdateAction
  }

  set isOpenModal(value: boolean) {

  }

  get modalTitle() {
    return this.isCreateAction ? this.$t(this.lblSetting.documentAdd) : this.$t(this.lblSetting.documentEditOrShare)
  }

  get AddButtonToolTip ()
  {
    return this.$t(this.lblSetting.documentAdd)
  }

  get maxWidth(): string {
    return '90%';
  }

  get buttonText() {
    return this.$t(this.lblSetting.documentSave)
  }

  get hasntAttachment() {
    return !this.document.attachments || !this.document.attachments.length
  }

  get searchVisible() {
    return !this.$route.path.endsWith('document')
  }

  created() {
    this.storeGetFunctionalities('document_management')
      .then(response => {
        if (this.$route.meta) Object.keys(response).forEach(key => this.$route.meta[key] = true)
        this.dtCanCreate = this.$route.meta['create_document']
      })
  }

  mounted() {
    this.storeGetDocumentsTypes()
      .then(res => console.log('resssssssp**********************************'))
  }

  handleAddDocument() {
    this.storeSetDocumentAction(CrudStatus.Create)
  }

  handleBeforeModalClose() {
    this.storeResetDocument()
  }

  handleClose() {

  }

  handleSave() {
    eventBus.$emit('DOC_SAVE_FILES_ATTRIBUTES',{})
    this.dtIsRecording = true
    if (this.isCreateAction)
      this.storeRecordDocument()
        .then(response => {
          let newDocuments = this.documents.map(x => {
            return {...x}
          })
          response.map(x => {
            newDocuments.unshift(x)
          })
          this.storeSetDocumentsList(newDocuments)
          // Update number of document in type doc
          let newTypes = this.documentTypes.map(x => {
            return {...x}
          })
          let idxType = newTypes.findIndex(x => x.fk_attachment_type === response[0].fk_attachment_type)
          newTypes[idxType].totalDocuments += 1
          this.storeSetDocumentTypes(newTypes)
        })
        .catch(err => {
          this.dtErrorModalVisible = true
          this.dtError = err
        })
        .finally(() => {
          this.dtIsRecording = false
          this.storeSetLoaderState({ key: DOCUMENT_LOADERS.TABLE_LOADER, value: false })
        })

    if (this.isUpdateAction)
      this.storeUpdateDocument()
        .then(response => {
          let newDocuments = this.documents.map(x => {
            return {...x}
          })
          let idxDoc = newDocuments.findIndex(x => x.id === response[0].id)
          newDocuments[idxDoc] = {...newDocuments[idxDoc], ...response[0]}
          this.storeSetDocumentsList(newDocuments)
          // this.$router.go(0)
        })
        .catch(err => {
          this.dtErrorModalVisible = true
          this.dtError = err
        })
        .finally(() => {
          this.dtIsRecording = false
          this.storeSetLoaderState({ key: DOCUMENT_LOADERS.TABLE_LOADER, value: false })
        })

  }

  handleRemoveError() {
    this.dtErrorModalVisible = false
    this.dtError = null;
  }

  onModalChangeBlock() {
    (this.$refs['base-modal'] as any).$forceUpdate()
  }
}

export default Document



// WEBPACK FOOTER //
// ./src/containers/documents/index.ts